
import ListComponent from "../../../components/ips/Index.vue";

export default {
  components: {
    ListComponent
  }
}
